import { LazyFactory } from 'app/core/core.types';

export const PasskeyOfferDialogFactory: LazyFactory = () => import('./passkey-offer-dialog.bundle');
